import React from 'react'
import { graphql, PageProps } from 'gatsby'
import Container from '../components/primitives/grid/container'
import Download from '../components/blocks/basic/download'
import StyledButton from '../components/primitives/styled-button'
import InlineSlider from '../components/primitives/inline-slider'
import SEO from '../components/SEO'

export const Head: React.FC<{ data: any }> = ({ data }) => {
    const post = data.wpPage
    return <SEO post={post} title={post?.seo?.title} />
}

const WpPost = ({
    data,
}: PageProps<Queries.WpPostPageQuery>): React.ReactElement => {
    const post = data.wpPost
    if (!post) {
        return <div className="spinner">Loading...</div>
    }
    return (
        <div css={{ width: '100%' }}>
            <div
                css={{
                    width: '100%',
                    height: 'auto',
                    display: 'flex',
                    position: 'relative',
                    alignItems: 'flex-start',
                    flexDirection: 'column',
                }}
            >
                <div
                    css={{
                        width: '100%',
                        display: 'flex',
                        height: '345px',
                        marginBottom: '40px',
                        flexDirection: 'column',
                        backgroundPosition: 'center right',
                        backgroundColor: '#F9F9F9',
                        backgroundRepeat: 'no-repeat',
                        backgroundSize: 'cover',
                        backgroundImage:
                            "url('/svgs/blog-post-background.svg')",
                        '@media(max-width: 767px)': {
                            marginBottom: '20px',
                        },
                    }}
                >
                    <Container>
                        <div
                            css={{
                                width: '100%',
                                height: 'auto',
                                display: 'grid',
                                gridGap: '20px',
                                flexDirection: 'column',
                                gridTemplateColumns: 'repeat(12, 1fr)',
                                '@media (max-width: 767px)': {
                                    gridGap: '16px',
                                    gridTemplateColumns: 'repeat(4, 1fr)',
                                },
                            }}
                        >
                            <time
                                className="p1"
                                css={{
                                    gridColumn: 'span 12',
                                    '@media (max-width: 767px)': {
                                        gridColumn: 'span 4',
                                    },
                                }}
                            >
                                {post?.date}
                            </time>
                            <h1
                                className="h0"
                                css={{
                                    gridColumn: 'span 12',
                                }}
                            >
                                {post?.title}
                            </h1>
                        </div>
                    </Container>
                </div>
                <div
                    css={{
                        width: '100%',
                        height: 'auto',
                        display: 'flex',
                        flexDirection: 'column',
                    }}
                >
                    <Container>
                        <div
                            css={{
                                width: '100%',
                                display: 'grid',
                                gridGap: '20px',
                                flexDirection: 'column',
                                gridTemplateColumns: 'repeat(12,1fr)',
                                '@media (max-width: 767px)': {
                                    gridGap: '16px',
                                    gridTemplateColumns: 'repeat(4,1fr)',
                                },
                            }}
                        >
                            <div
                                css={{
                                    width: '100%',
                                    display: 'flex',
                                    gridColumn: 'span 9',
                                    borderColor: '#E2E2E2',
                                    flexDirection: 'column',
                                    paddingBottom: '52px',
                                    borderBottom: '1px #e2e2e2',
                                    borderStyle: 'solid',
                                    '@media (max-width: 767px)': {
                                        order: '2',
                                        gridColumn: 'span 4',
                                    },
                                }}
                            >
                                <div
                                    dangerouslySetInnerHTML={{
                                        __html: post?.content,
                                    }}
                                    css={{ marginBottom: '20px' }}
                                    className="ql-editor p1"
                                />

                                {post?.posten?.downloads &&
                                    post.posten.downloads.map(
                                        (download: any, idx: number) => (
                                            <div
                                                css={{
                                                    marginBottom: '12px',
                                                    width: 'auto',
                                                }}
                                                key={idx}
                                            >
                                                <Download
                                                    file={{
                                                        href:
                                                            download.file
                                                                .localFile
                                                                .publicURL,
                                                    }}
                                                    title={download.name}
                                                    style={{
                                                        paddingLeft:
                                                            '0px !important',
                                                        paddingRight:
                                                            '0px !important',
                                                    }}
                                                />
                                            </div>
                                        )
                                    )}
                            </div>
                            <div
                                css={{
                                    width: '100%',
                                    display: 'flex',
                                    gridColumn: 'span 3',
                                    flexDirection: 'column',
                                    '@media (max-width: 767px)': {
                                        order: 1,
                                        gridColumn: 'span 4',
                                    },
                                }}
                            >
                                {post?.featuredImage?.node && (
                                    <div
                                        css={{
                                            width: '100%',
                                            height: 'auto',
                                            display: 'flex',
                                            flexDirection: 'column',
                                        }}
                                    >
                                        <InlineSlider
                                            slides={[
                                                {
                                                    image:
                                                        post?.featuredImage
                                                            ?.node,
                                                    caption:
                                                        post?.featuredImage
                                                            ?.node?.altText,
                                                },
                                            ]}
                                        />
                                    </div>
                                )}
                                {post?.posten?.slider &&
                                    post?.posten?.slider.length > 0 && (
                                        <div
                                            css={{
                                                width: '100%',
                                                height: 'auto',
                                                marginTop: '29px',
                                            }}
                                        >
                                            <InlineSlider
                                                slides={post?.posten?.slider}
                                            />
                                        </div>
                                    )}
                            </div>
                            <div
                                css={{
                                    width: '100%',
                                    display: 'flex',
                                    marginTop: '51px',
                                    gridColumn: 'span 12',
                                    '@media (max-width: 767px)': {
                                        order: '3',
                                        marginTop: '28px',
                                        gridColumn: 'span 4',
                                    },
                                }}
                            >
                                <StyledButton
                                    to="#"
                                    onClick={() => {
                                        window.history.back()
                                    }}
                                    arrowLeft
                                    theme="secondary"
                                    css={{ marginBottom: '100px' }}
                                >
                                    Zurück
                                </StyledButton>
                            </div>
                        </div>
                    </Container>
                </div>
            </div>
        </div>
    )
}
export default WpPost

export const query = graphql`
    query WpPostPage($id: String) {
        wpPost(id: { eq: $id }) {
            title
            date(formatString: "DD.MM.YYYY")
            featuredImage {
                node {
                    altText
                    localFile {
                        childImageSharp {
                            gatsbyImageData(quality: 100)
                        }
                    }
                }
            }
            posten {
                downloads {
                    name
                    file {
                        localFile {
                            publicURL
                        }
                    }
                }
                slider {
                    caption
                    image {
                        localFile {
                            publicURL
                            childImageSharp {
                                gatsbyImageData
                            }
                        }
                    }
                }
            }
            excerpt
            content
            seo {
                breadcrumbs {
                    text
                    url
                }
                title
                metaDesc
                focuskw
                metaKeywords
                opengraphTitle
                opengraphDescription
                opengraphImage {
                    altText
                    sourceUrl
                    srcSet
                }
                twitterTitle
                twitterDescription
                twitterImage {
                    altText
                    sourceUrl
                    srcSet
                }
                canonical
                cornerstone
                schema {
                    articleType
                    pageType
                    raw
                }
                metaRobotsNofollow
                metaRobotsNoindex
            }
        }
    }
`
